module.exports = __webpack_public_path__ + "img/daping.ef5d4276.jpg";